import { getUserPrompt, setUserPrompt } from '@/pages/opinion/services';
import { useState } from 'react';
import { PromptType } from '../types';
import { getPromptText } from '../utils';

export default function useGptHistoryPrompt({
  gameInfo,
  promptList,
}: {
  gameInfo: any;
  promptList: Array<PromptType>;
}) {
  const [userPromptList, setUserPromptList] = useState<
    Array<{ prompt_detail: string; update_time: string }>
  >([]);
  const [loading, setLoading] = useState(false);

  const getUserHistoryPrompt = () => {
    if (gameInfo?.edition_unified_id) {
      setLoading(true);
      getUserPrompt({
        edition_unified_id: gameInfo.edition_unified_id,
        page: 1,
        page_size: 5,
      })
        .then((data) => {
          setUserPromptList(data || []);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const setUserHistoryPrompt = (value: string, id?: string) => {
    const flag = promptList.some((item) => getPromptText(item) === value);
    const historyFlag = userPromptList.some(
      (item: any) => item.prompt_detail === value,
    );
    if (flag || historyFlag) return;
    if(!value) return;

    setUserPrompt({
      edition_unified_id: gameInfo.edition_unified_id,
      prompt: value,
      id,
    });
  };

  return {
    loading,
    userPromptList,
    setUserHistoryPrompt,
    getUserHistoryPrompt,
  };
}
